import React from 'react';
import { aboutContent } from '../data/homeContent';

const AboutUs = () => (
  <div className="">
    {/* Hero Section */}
    <section className={`${aboutContent.hero.bgColor} text-white py-20`}>
      <div className="container mx-auto px-6 text-center">
        <h1 className="text-5xl font-bold mb-6">{aboutContent.hero.title}</h1>
        <p className="text-xl max-w-3xl mx-auto">{aboutContent.hero.subtitle}</p>
      </div>
    </section>

    {/* Our Story Section */}
    <section className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center">
          {/* SVG content remains the same */}
          <div className="md:w-1/2 mb-10 md:mb-0">
            <svg className="w-full" viewBox="0 0 600 400"
              xmlns="http://www.w3.org/2000/svg">
              <rect width="600" height="400" fill="#f8fafc" />
              <path d="M0,250 Q150,200 300,300 T600,250"
                fill="#18cb96" opacity="0.3" />
              <path d="M0,220 Q150,170 300,270 T600,220"
                fill="#18cb96" opacity="0.5" />
              <g transform="translate(150, 100)">
                <rect x="0" y="0" width="300" height="180"
                  rx="10" fill="white" stroke="#18cb96"
                  strokeWidth="3" />
                <circle cx="50" cy="40" r="20"
                  fill="#18cb96" />
                <circle cx="100" cy="40" r="20"
                  fill="#18cb96" opacity="0.7" />
                <circle cx="150" cy="40" r="20"
                  fill="#18cb96" opacity="0.4" />
                <rect x="30" y="90" width="240" height="15"
                  rx="3" fill="#e2e8f0" />
                <rect x="30" y="120" width="180" height="15"
                  rx="3" fill="#e2e8f0" />
                <rect x="30" y="150" width="210" height="15"
                  rx="3" fill="#e2e8f0" />
              </g>
              <text x="300" y="340" textAnchor="middle"
                fontFamily="Arial" fontSize="16"
                fill="#475569">Our Journey from 2015 to
                Today</text>
            </svg>
          </div>
          <div className="md:w-1/2 md:pl-12">
            <h2 className="text-4xl font-bold mb-6 text-custom-green">{aboutContent.ourStory.title}</h2>
            {aboutContent.ourStory.content.map((paragraph, index) => (
              <p key={index} className="text-lg mb-6" dangerouslySetInnerHTML={{ __html: paragraph }}></p>
            ))}
          </div>
        </div>
      </div>
    </section>

    {/* What Are You Using Section */}
    <section className="py-16 bg-gray-100">
      <div className="container mx-auto px-6">
        <h2 className="text-4xl font-bold mb-12 text-center text-custom-green">{aboutContent.whatAreYouUsing.title}</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {aboutContent.whatAreYouUsing.features.map((feature, index) => (
            <div key={index} className="bg-white p-8 rounded-lg shadow-md text-center">
              {/* Icon and content based on feature.icon */}
              <h3 className="text-2xl font-bold mb-4">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Our Vision and Mission Section */}

<section className="py-16 bg-gradient-to-br from-gray-50 to-white">
  <h2
    className="text-4xl font-bold text-custom-green text-center">Future Goals</h2>
  <div className="container mx-auto px-6">
    {/* Main Title */}
    <div className="text-center mb-16">
      <h2 className="text-5xl font-bold text-custom-green bg-gradient-to-r from-custom-green to-green-400 bg-clip-text text-transparent">Future Goals</h2>
    </div>

    {/* Three Column Layout: Card - SVG - Card */}
    <div className="flex flex-col lg:flex-row gap-8 items-center justify-center">

      {/* Left Card: Short-Term Goals */}
      <div className="lg:w-1/2 w-full mx-auto">
        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl p-8 border-l-4 border-blue-500 shadow-lg hover:shadow-xl transition-all duration-300 min-h-[680px]">
          <h3 className="text-2xl font-bold mb-6 text-blue-700">🚀 Short-Term Goals (2025):</h3>

          <div className="grid grid-cols-1 gap-4">
            <div className="flex items-start space-x-4 p-3 bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-200">
              <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                <span className="text-blue-600 font-bold text-sm">β</span>
              </div>
              <span className="text-gray-700 font-medium">Launch public beta of SnapPOS</span>
            </div>

            <div className="flex items-start space-x-4 p-3 bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-200">
              <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                <span className="text-blue-600 font-bold text-sm">📺</span>
              </div>
              <span className="text-gray-700 font-medium">Introduce customer-facing display and kitchen display system</span>
            </div>

            <div className="flex items-start space-x-4 p-3 bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-200">
              <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                <span className="text-blue-600 font-bold text-sm">🔗</span>
              </div>
              <span className="text-gray-700 font-medium">Add integrations for takeaway and delivery platforms</span>
            </div>

            <div className="flex items-start space-x-4 p-3 bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-200">
              <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                <span className="text-blue-600 font-bold text-sm">📚</span>
              </div>
              <span className="text-gray-700 font-medium">Expand onboarding and help resources</span>
            </div>

            <div className="flex items-start space-x-4 p-3 bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-200">
              <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                <span className="text-blue-600 font-bold text-sm">📊</span>
              </div>
              <span className="text-gray-700 font-medium">Roll out cost-control dashboards and profit analytics tools</span>
            </div>

            <div className="flex items-start space-x-4 p-3 bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-200">
              <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                <span className="text-blue-600 font-bold text-sm">💰</span>
              </div>
              <span className="text-gray-700 font-medium">Begin offering subscription-based pricing, including a free tier for micro businesses</span>
            </div>
          </div>
        </div>
      </div>

  
      <div className="lg:w-1/2 w-full mx-auto">
        <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-2xl p-8 border-l-4 border-custom-green shadow-lg min-h-[680px]">

          <div className="flex items-center mb-6">

            <h3 className="text-2xl font-bold mb-6  text-custom-green">🌍 Long-Term Goals(2026+)</h3>
          </div>

          <div className="space-y-4">
            {/* Accounting Integration */}
            <div className="flex items-start space-x-4 p-4 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow">
              <div className="bg-blue-100 rounded-full p-2 flex-shrink-0">
                <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"></path>
                </svg>
              </div>
              <p className="text-gray-700 leading-relaxed">
                <span className="font-semibold">Integrate with accounting platforms</span> (e.g., Xero, QuickBooks)
              </p>
            </div>

            {/* Mobile Apps */}
            <div className="flex items-start space-x-4 p-4 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow">
              <div className="bg-purple-100 rounded-full p-2 flex-shrink-0">
                <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 18h.01M8 21h8a1 1 0 001-1V4a1 1 0 00-1-1H8a1 1 0 00-1 1v16a1 1 0 001 1z"></path>
                </svg>
              </div>
              <p className="text-gray-700 leading-relaxed">
                <span className="font-semibold">Launch mobile apps</span> for Android and iOS
              </p>
            </div>

            {/* AI Assistant */}
            <div className="flex items-start space-x-4 p-4 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow">
              <div className="bg-indigo-100 rounded-full p-2 flex-shrink-0">
                <svg className="w-6 h-6 text-indigo-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"></path>
                </svg>
              </div>
              <p className="text-gray-700 leading-relaxed">
                <span className="font-semibold">Develop an AI-powered profitability assistant</span> for smarter decision-making
              </p>
            </div>

            {/* Hardware Partnership */}
            <div className="flex items-start space-x-4 p-4 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow">
              <div className="bg-green-100 rounded-full p-2 flex-shrink-0">
                <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
                </svg>
              </div>
              <p className="text-gray-700 leading-relaxed">
                <span className="font-semibold">Partner with refurbished hardware providers</span> to support sustainable tech use
              </p>
            </div>

            {/* International Expansion */}
            <div className="flex items-start space-x-4 p-4 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow">
              <div className="bg-orange-100 rounded-full p-2 flex-shrink-0">
                <svg className="w-6 h-6 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
              </div>
              <p className="text-gray-700 leading-relaxed">
                <span className="font-semibold">Expand to international markets</span>, starting with Europe and South Asia
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Mobile Responsive Alternative Layout */}
    <div className="lg:hidden mt-12 text-center text-sm text-gray-500">
      On mobile devices, the layout stacks vertically for better readability
    </div>
  </div>
</section>

    {/* Demo Component Section - Enhanced */}
    <section className="py-20 lg:py-32 bg-[#51dcb1] relative overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute top-10 left-1/3 w-32 h-32 bg-white opacity-10 rounded-full animate-pulse"></div>
        <div className="absolute bottom-10 right-1/4 w-24 h-24 bg-white opacity-10 rounded-full animate-bounce"></div>
      </div>
      <div className="container mx-auto px-6 text-center relative z-10">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-12 text-white">See Our Solution in Action</h2>
        <div className="bg-white p-8 rounded-2xl shadow-2xl max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-8">
          <div className="md:w-1/2 mb-6 md:mb-0">
            {/* SVG Demo Mockup */}
            <svg className="w-full" viewBox="0 0 500 300" xmlns="http://www.w3.org/2000/svg">
              <rect width="500" height="300" fill="#f8fafc" />
              <rect x="50" y="30" width="400" height="240" rx="6" fill="white" stroke="#d1d5db" strokeWidth="1" />
              <rect x="50" y="30" width="400" height="40" rx="6" fill="#18cb96" />
              <circle cx="80" cy="50" r="10" fill="white" opacity="0.8" />
              <rect x="100" y="45" width="60" height="10" rx="2" fill="white" opacity="0.8" />
              <rect x="380" y="45" width="40" height="10" rx="2" fill="white" opacity="0.8" />
              <rect x="50" y="70" width="80" height="200" fill="#f3f4f6" />
              <rect x="65" y="90" width="50" height="8" rx="2" fill="#18cb96" opacity="0.7" />
              <rect x="65" y="110" width="50" height="8" rx="2" fill="#9ca3af" />
              <rect x="65" y="130" width="50" height="8" rx="2" fill="#9ca3af" />
              <rect x="65" y="150" width="50" height="8" rx="2" fill="#9ca3af" />
              <rect x="65" y="170" width="50" height="8" rx="2" fill="#9ca3af" />
              <rect x="150" y="80" width="80" height="60" rx="4" fill="white" stroke="#d1d5db" strokeWidth="1" />
              <rect x="160" y="90" width="40" height="8" rx="2" fill="#9ca3af" />
              <rect x="160" y="110" width="60" height="20" rx="2" fill="#18cb96" opacity="0.2" />
              <rect x="240" y="80" width="80" height="60" rx="4" fill="white" stroke="#d1d5db" strokeWidth="1" />
              <rect x="250" y="90" width="40" height="8" rx="2" fill="#9ca3af" />
              <rect x="250" y="110" width="60" height="20" rx="2" fill="#18cb96" opacity="0.2" />
              <rect x="330" y="80" width="80" height="60" rx="4" fill="white" stroke="#d1d5db" strokeWidth="1" />
              <rect x="340" y="90" width="40" height="8" rx="2" fill="#9ca3af" />
              <rect x="340" y="110" width="60" height="20" rx="2" fill="#18cb96" opacity="0.2" />
              <rect x="150" y="150" width="260" height="110" rx="4" fill="white" stroke="#d1d5db" strokeWidth="1" />
              <rect x="160" y="160" width="80" height="8" rx="2" fill="#111827" />
              <rect x="170" y="180" width="20" height="60" rx="2" fill="#18cb96" opacity="0.3" />
              <rect x="200" y="200" width="20" height="40" rx="2" fill="#18cb96" opacity="0.5" />
              <rect x="230" y="170" width="20" height="70" rx="2" fill="#18cb96" opacity="0.7" />
              <rect x="260" y="190" width="20" height="50" rx="2" fill="#18cb96" opacity="0.6" />
              <rect x="290" y="150" width="20" height="90" rx="2" fill="#18cb96" opacity="0.8" />
              <rect x="320" y="180" width="20" height="60" rx="2" fill="#18cb96" opacity="0.4" />
              <rect x="350" y="210" width="20" height="30" rx="2" fill="#18cb96" opacity="0.5" />
              <line x1="160" y1="240" x2="380" y2="240" stroke="#d1d5db" strokeWidth="1" />
              <text x="250" y="280" textAnchor="middle" fontFamily="Arial" fontSize="14" fill="#475569">
                Interactive Dashboard Demo
              </text>
            </svg>
          </div>
          <div className="md:w-1/2 md:pl-8 text-left">
            <h3 className="text-2xl font-bold mb-4 text-custom-green">Interactive Demo</h3>
            <p className="text-gray-600 mb-6">
              Experience the power and simplicity of our retail management solution with our interactive demo. See firsthand how our features can transform your business operations.
            </p>
            <a
              href="https://restro.snapposs.com/signup"
              className="inline-block bg-[#51dcb1] hover:bg-[#12a373] text-white font-bold py-3 px-8 rounded-lg transition duration-300 shadow-lg hover:scale-105"
              target="_blank" rel="noopener noreferrer"
            >
              Start Demo
            </a>
          </div>
        </div>
      </div>
    </section>

    {/* Milestones Timeline Section - Enhanced */}
    <section className="py-20 lg:py-32 gradient-bg relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <svg className="w-full h-full" viewBox="0 0 1200 800" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#18cb96" stopOpacity="0.1" />
              <stop offset="100%" stopColor="#12a373" stopOpacity="0.05" />
            </linearGradient>
          </defs>
          <circle cx="200" cy="150" r="120" fill="url(#grad1)" />
          <circle cx="1000" cy="300" r="80" fill="url(#grad1)" />
          <circle cx="800" cy="600" r="100" fill="url(#grad1)" />
          <circle cx="100" cy="650" r="60" fill="url(#grad1)" />
        </svg>
      </div>
      <div className="container mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-[#51dcb1] rounded-full mb-6 shadow-lg">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-800">
            🟦 <span className="milestone-year">Milestones</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our journey from concept to reality - building the future of point-of-sale technology
          </p>
        </div>
        {/* Timeline */}
        <div className="relative milestone-timeline max-w-3xl mx-auto">
          {/* Vertical line */}
          <div className="absolute left-8 top-0 bottom-0 w-1 bg-gradient-to-b from-[#51dcb1] to-green-200 rounded-full"></div>
          {/* Milestone Items */}
          <div className="space-y-12">
            {/* 2023 Milestone */}
            <div className="relative flex items-start">
              {/* Dot */}
              <div className="absolute left-6 w-4 h-4 milestone-dot rounded-full flex items-center justify-center">
                <div className="w-2 h-2 bg-white rounded-full"></div>
              </div>

              {/* Content */}
              <div className="ml-16 milestone-card glass-card p-8 rounded-2xl shadow-lg">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
                  <h3 className="text-3xl font-bold milestone-year mb-2 md:mb-0">✅ 2023</h3>
                  <span className="inline-flex items-center px-4 py-2 rounded-full text-sm font-medium bg-green-100 text-green-800">
                    Conceptualization
                  </span>
                </div>
                <p className="text-gray-700 text-lg leading-relaxed">
                  Conceptualized SnapPOS after identifying inefficiencies in existing POS systems. Recognized the need for affordable, flexible, and powerful solutions for SMEs.
                </p>
              </div>
            </div>

            {/* Early 2024 Milestone */}
            <div className="relative flex items-start">
              <div className="absolute left-6 w-4 h-4 milestone-dot rounded-full flex items-center justify-center">
                <div className="w-2 h-2 bg-white rounded-full"></div>
              </div>

              <div className="ml-16 milestone-card glass-card p-8 rounded-2xl shadow-lg">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
                  <h3 className="text-3xl font-bold milestone-year mb-2 md:mb-0">✅ Early 2024</h3>
                  <span className="inline-flex items-center px-4 py-2 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                    Development Started
                  </span>
                </div>
                <p className="text-gray-700 text-lg leading-relaxed">
                  Development began with a focus on core features: billing, inventory management, multi-device support, and offline mode capabilities to ensure reliability.
                </p>
              </div>
            </div>

            {/* Mid 2024 Milestone */}
            <div className="relative flex items-start">
              <div className="absolute left-6 w-4 h-4 milestone-dot rounded-full flex items-center justify-center">
                <div className="w-2 h-2 bg-white rounded-full"></div>
              </div>

              <div className="ml-16 milestone-card glass-card p-8 rounded-2xl shadow-lg">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
                  <h3 className="text-3xl font-bold milestone-year mb-2 md:mb-0">✅ Mid 2024</h3>
                  <span className="inline-flex items-center px-4 py-2 rounded-full text-sm font-medium bg-purple-100 text-purple-800">
                    MVP Completed
                  </span>
                </div>
                <p className="text-gray-700 text-lg leading-relaxed">
                  Completed our MVP and conducted extensive testing in hospitality environments including restaurants and cafés, gathering valuable user feedback.
                </p>
              </div>
            </div>

            {/* Late 2024 Milestone */}
            <div className="relative flex items-start">
              <div className="absolute left-6 w-4 h-4 milestone-dot rounded-full flex items-center justify-center">
                <div className="w-2 h-2 bg-white rounded-full"></div>
              </div>

              <div className="ml-16 milestone-card glass-card p-8 rounded-2xl shadow-lg">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
                  <h3 className="text-3xl font-bold milestone-year mb-2 md:mb-0">✅ Late 2024</h3>
                  <span className="inline-flex items-center px-4 py-2 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800">
                    Business Formation
                  </span>
                </div>
                <p className="text-gray-700 text-lg leading-relaxed">
                  Registered JK Business Analytics Ltd to support SnapPOS and future SME-focused solutions, establishing a solid legal foundation for growth.
                </p>
              </div>
            </div>

            {/* 2025 Milestone */}
            <div className="relative flex items-start">
              <div className="absolute left-6 w-4 h-4 milestone-dot rounded-full flex items-center justify-center">
                <div className="w-2 h-2 bg-white rounded-full"></div>
              </div>

              <div className="ml-16 milestone-card glass-card p-8 rounded-2xl shadow-lg border-2 border-custom-green">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
                  <h3 className="text-3xl font-bold milestone-year mb-2 md:mb-0">✅ 2025</h3>
                  <span className="inline-flex items-center px-4 py-2 rounded-full text-sm font-medium bg-[#51dcb1] text-white animate-pulse">
                    Current Phase
                  </span>
                </div>
                <p className="text-gray-700 text-lg leading-relaxed">
                  Preparing for public beta launch and integration of advanced analytics tools. Focus on user onboarding, performance optimization, and market readiness.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Call to Action */}
        {/* <div className="text-center mt-16">
          <div className="glass-card p-8 rounded-2xl shadow-lg max-w-2xl mx-auto bg-white/80">
            <h3 className="text-2xl font-bold text-gray-800 mb-4">Join Our Journey</h3>
            <p className="text-gray-600 mb-6">Be part of the next milestone in retail technology innovation</p>
            <a href="./contact.html" className="bg-[#51dcb1] hover:bg-opacity-90 text-white font-bold py-3 px-8 rounded-lg transition duration-300 transform hover:scale-105">
              Get Early Access
            </a>
          </div>
        </div> */}
      </div>
    </section>
  </div>
);

export default AboutUs;
